module.exports = __webpack_public_path__ + "img/adel.faa999f.png";